import type { RouteObject } from 'react-router-dom';

import type { EventId } from './MODAL_EVENT_ID';
import { EVENT_ID } from './MODAL_EVENT_ID';
import InstructorCouponModalWrapper from '../components/InstructorCouponModal/InstructorCouponModal';
import IntegratedCertificationModal from '../components/IntegratedCertificationModal/IntegratedCertificationModal';
import SettlementModalWrapper from '../components/SettlementModal/SettlementModal';

export const routes: (RouteObject & { eventId?: EventId })[] = [
  {
    path: '/instructor/coupons',
    element: <InstructorCouponModalWrapper />,
    eventId: EVENT_ID.INSTRUCTOR_COUPON_MODAL,
  },
  {
    path: '/course/:slug',
    element: <IntegratedCertificationModal />,
    eventId: EVENT_ID.INTEGRATED_CERTIFICATION_MODAL,
  },
  {
    path: '/mentors/:id/edit',
    element: <SettlementModalWrapper />,
    eventId: EVENT_ID.SETTLEMENT_MODAL,
  },
  {
    path: '*',
    element: null,
  },
];
